import $ from 'jquery';
import { throttle } from 'throttle-debounce';


window.addEventListener('DOMContentLoaded', function () {
    const bar = $('.fixed-call-to-action');
    const topnav = $('#top-nav');
    const requiredMovement = 25;

    const hide = () => bar.css({ top: -bar.outerHeight(), opacity: 0 });
    const show = () => bar.css({ top: 0, opacity: 1 });
    const now = () => +new Date() / 1000;

    var lastDistance = 0;
    var longestDistance = 0;
    var lastScroll = now();

    if (bar.length === 0) {
        return;
    }

    hide();

    let handleScroll = throttle(250, function () {
        var topnavHeight = topnav.outerHeight();
        var distance = window.pageYOffset;

        // there was scroll movement
        if (distance !== lastDistance) {
            // scrolling up
            if (lastDistance - distance > 0) {
                if (longestDistance - distance > requiredMovement) {
                    show();
                }
                // scrolling down
            } else {
                hide();
                longestDistance = distance;
            }

            // do not hide real header
            if (distance < topnavHeight) {
                hide();
            }

            lastDistance = distance;
        }

        if (now() - lastScroll < 2) {
            handleScroll();
        }
    });

    const updateAndHandleScroll = throttle(250, function () {
        if (window.innerWidth <= 767) {
            lastScroll = now();
            handleScroll();
        }
    });

    $(window).scroll(updateAndHandleScroll);
    $('body').on('touchstart touchend touchmove', updateAndHandleScroll);
    setTimeout(() => bar.css('display', ''), 250);
});
